export const PLAY_RHYM_URL =
  process.env.REACT_APP_PLAY_RHYM_URL || 'https://play.rhym.io';
